'use strict';

var ContentUserEvent = {
    componentDidMount: function componentDidMount() {
        document.addEventListener('scroll', this.onContentScroll, false);
        window.addEventListener('click', this.onContentClick, false);
    },
    componentWillUnmount: function componentWillUnmount() {
        document.removeEventListener('scroll', this.onContentScroll, false);
        window.removeEventListener('click', this.onContentClick, false);
    }
};

module.exports = ContentUserEvent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/mixins/ContentUserEvent.js
// module id = 310
// module chunks = 0 1 2 3 5 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26